import _ from 'lodash'
import { FormGroup, Icons, Input, Progress, Radio, RadioItem } from '@agro-club/agroclub-shared'
import { FormikProps } from 'formik'
import { PositionDTO, UsContractDTO, UsPricingTypes, UsTransportModes } from 'modules/domain/usContracts/types'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { AButton } from 'views/components/Analytics'
import { labelTarif } from 'modules/utils/numbers/formatTarif'
import { ShortFormControl } from 'views/styled/common'
import { SharedModalFooter } from 'views/components/SharedModal'

type Props = {
  formik: FormikProps<UsContractDTO>
  formProgress: Progress
  onClose: () => void
}

const defaultPosition: PositionDTO = {
  symbol: '',
  symbolObjectId: null,
  pricing_type: UsPricingTypes.basis,
  quantity: '',
  futures_price: '',
  basis: '',
  price: '',
  freight_cost: '',
  start_date: '',
  end_date: '',
  transport_mode: UsTransportModes.truck,
}

export const Controls: FC<Props> = ({ formik, formProgress, onClose }) => {
  const { t } = useTranslation('usContracts')

  return (
    <SharedModalFooter>
      <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
        <div style={{ display: 'flex', gap: 16 }}>
          <AButton id="save" size="big" progress={formProgress} color="primary" onClick={formik.submitForm}>
            {t('common:save')}
          </AButton>

          <AButton size="big" color="secondary" onClick={onClose} id="cancel">
            {t('common:cancel')}
          </AButton>
        </div>
        <AButton
          id="addPosition"
          size="big"
          progress={formProgress}
          Icon={Icons.IconAdd}
          color="secondary"
          border="dashed"
          background="none"
          // { ...defaultPosition } required to create a NEW new object
          onClick={() => formik.setFieldValue('positions', [...formik.values.positions, ...[{ ...defaultPosition }]])}
        >
          {t('addPosition')}
        </AButton>
      </div>
    </SharedModalFooter>
  )
}

export const PricingTypeRadio: FC<{
  formik: FormikProps<UsContractDTO>
  fieldName: string
  disabled?: boolean
}> = ({ formik, fieldName, disabled }) => {
  const { t } = useTranslation('usContracts')
  return (
    <FormGroup
      error={_.get(formik.errors, fieldName)}
      label={t('fields.contractType')}
      // TODO center
      style={{ alignItems: 'center' }}
    >
      <Radio onChange={(value) => formik.setFieldValue(fieldName, value)} value={_.get(formik.values, fieldName)}>
        <RadioItem value={UsPricingTypes.priced} label={t('usPricingTypes.priced')} disabled={disabled} />
        <RadioItem value={UsPricingTypes.basis} label={t('usPricingTypes.basis')} disabled={disabled} />
      </Radio>
    </FormGroup>
  )
}

export const PriceField: FC<{
  formik: FormikProps<UsContractDTO>
  fieldName: string
  label: string
}> = ({ formik, fieldName, label }) => {
  const error = _.get(formik.errors, fieldName)
  return (
    <ShortFormControl>
      <FormGroup label={labelTarif(label)} error={error}>
        <Input {...formik.getFieldProps(fieldName)} invalid={!!error} type={'number'} />
      </FormGroup>
    </ShortFormControl>
  )
}
